import PropTypes from 'prop-types';
import { Paragraph } from '@cof/plastic-components';
import { styled } from 'styled-components';

const PoweredByWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 4rem;
    padding-top: 2.4rem;
`;

const DOneLogo = styled.img`
    height: 1.4rem;
    margin: 0 0.4rem;
    display: inline-block;
`;

const ObLandingPoweredBy = ({ paragraphVariant, dOneLogo }: any) => (
    <PoweredByWrapper>
        {/* @ts-expect-error TS2322: Type '"small"' is not assignable to type 'keyof FontSizeKeys | null'. */}
        <Paragraph variant={paragraphVariant} fontSize={['small', null, 'small']} fontWeight="400" data-qm-allow pb={0}>
            Powered by
        </Paragraph>
        <DOneLogo src={dOneLogo} alt="D One Logo" />
    </PoweredByWrapper>
);

ObLandingPoweredBy.propTypes = {
    paragraphVariant: PropTypes.string.isRequired,
    dOneLogo: PropTypes.string.isRequired
};

export default ObLandingPoweredBy;
